export var getColor = function getColor(disabled, active) {
  if (disabled) return 'disabled';
  if (active) return 'primary';
  return 'secondary';
};